import algosdk from "algosdk";
import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useWallet } from "../context/WalletContext";
import { useTransaction } from "../context/TransactionContext";
import "../styles/general.css";
import "../styles/marketplace.css";

interface Item {
 id: string;
 name: string;
 image: string;
 description: string;
 price: number;
category: 'Eventos' | 'Entretenimiento' | 'Bienestar' ;
}


const items: Item[] = [
 {
  id: "HBO",
  name: "Membresia HBO - Max mes",
  image: "/images/marketplace/HBO.jpeg",
  description: "Disfruta de una de tus plataforma favoritas*",
  price: 8000,
  category: "Entretenimiento",
 },
 {
  id: "Paramount",
  name: "Membresia Paramount mes",
  image: "/images/marketplace/Paramount.jpeg",
  description: "Disfruta de una de tus plataforma favoritas*",
  price: 8000,
  category: "Entretenimiento",
 },
 {
  id: "Netflix",
  name: "Membresia Netflix mes",
  image: "/images/marketplace/Netflix.jpeg",
  description: "Disfruta de una de tus plataforma favoritas*",
  price: 14000,
  category: "Entretenimiento",
 },
 {
  id: "USDC",
  name: "Mox Coins Changes",
  image: "/images/usdc_mox.png",
  description: "Proximamente podrás Cambiar tus Mox Coins por USDC. ",
  price: 4000,
  category: "Entretenimiento",
 },
 {
  id: "Mini almuerzo",
  name: "Mini almuerzo",
  image: "/images/marketplace/almuerzo.jpg", 
  description: "Almuerzo base: bebida - lenteja/pasta - huevo/platano y arroz",
  price: 5000,
    category: "Bienestar",
 },
 {
  id: "Mini desayuno",
  name: "Mini desayuno",
  image: "/images/marketplace/desayuno.jpg", 
  description: "Almuerzo base: bebida - lenteja/pasta - huevo/platano y arroz",
  price: 5000,
    category: "Bienestar",
 },
 {
  id: "Lavanderia",
  name: "Alquiler Lavadora",
  image: "/images/marketplace/lavanderia.jpg", 
  description: "Servicio de lavanderia durante 12 horas continuas",
  price: 12000,
    category: "Bienestar",
 },
];

const categories = [
  { id: 'Bienestar', title: 'Bienestar' },
  { id: 'Entretenimiento', title: 'Entretenimiento' },
];

const ItemCard = ({ item, onPurchase }: { item: Item, onPurchase: (item: Item) => void }) => {
  const isUSDC = item.id === "USDC"; 

  return (
    <div
      key={item.id}
      className={`item-card ${isUSDC ? "disabled-item" : ""}`}
    >
      <img src={item.image} alt={item.name} width="200" />
      <h4>{item.name}</h4>
      <p>{item.description}</p>
      <strong>{item.price} UMQ</strong> 
      {!isUSDC && (
        <button
          className="button-secondary"
          onClick={() => onPurchase(item)}
        >
          Reclamar
        </button>
      )}
      {isUSDC && (
        <button className="button-secondary" disabled>
          Pronto.
        </button>
      )}
    </div>
  );
};


const Marketplace = ({ algodClient, setMessage }: { algodClient: algosdk.Algodv2, setMessage: (msg: string) => void }) => {
 const appId = 748946547;
 const appAddress = "HPBA7TGAK6YFVL7EXDSMR4PBTOOH26UIJGPY7UTI2ZMPGMGFFNIP7AA7UU";
 const navigate = useNavigate();
 const asaId = 748884896;

 const { account } = useWallet();
 const { openTransactionModal } = useTransaction();
 const accountAddress = account?.addr || "";
 const [userUmqEnviados, setUserUmqEnviados] = useState<number>(0);
 const [hasOptedIn, setHasOptedIn] = useState<boolean>(false);

 const readAppGlobalState = useCallback(async () => {
  try {
   const userState = await algodClient.accountInformation(accountAddress).do();
   const localState = userState["apps-local-state"]?.find((app: any) => app.id === appId);
   const umalliq = localState?.["key-value"]?.find(
    (kv: any) => Buffer.from(kv.key, "base64").toString() === "umalliq_enviados"
   )?.value?.uint;

   setHasOptedIn(!!localState);
   setUserUmqEnviados(umalliq || 0);
  } catch (error) {
   console.error("Error en readAppGlobalState:", error);
  }
 }, [accountAddress, algodClient]);

 const optInToApp = useCallback(async () => {
   try {
    if (!account?.sk || !account?.addr) throw new Error("Wallet no conectada");
  
    const suggestedParams = await algodClient.getTransactionParams().do();
    const optInTxn = algosdk.makeApplicationOptInTxn(account.addr, suggestedParams, appId);
  
    const signedTxn = optInTxn.signTxn(account.sk);
    const { txId } = await algodClient.sendRawTransaction(signedTxn).do();
  
    setMessage(`Opt-in exitoso. TxID: ${txId}`);
    setHasOptedIn(true);
   } catch (err) {
    console.error(err);
    setMessage("Error al hacer opt-in");
   }
  }, [account, algodClient, appId, setMessage]);


 const handlePurchase = (item: Item) => {
 openTransactionModal({
  recipient: appAddress,
  amount: item.price,
  asset: { name: "UMQ", id: 748884896, decimals: 9 },
  onConfirm: async () => {
   try {
    const suggestedParams = await algodClient.getTransactionParams().do();
    const note = new TextEncoder().encode(`${item.id}`);

    const feeTxn = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
     from: accountAddress,
     to: appAddress,
     assetIndex: asaId,
     amount: 15e9, // 15 UMQ
     suggestedParams,
    });

    const assetTransferTxn = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
     from: accountAddress,
     to: appAddress,
     assetIndex: asaId,
     amount: item.price * 1e9,
     suggestedParams,
     note,
    });

    const appCallTxn = algosdk.makeApplicationNoOpTxnFromObject({
     from: accountAddress,
     suggestedParams,
     appIndex: appId,
     appArgs: [
      new Uint8Array(Buffer.from("buy")),
      new Uint8Array(Buffer.from(item.id)),
     ],
     foreignAssets: [asaId],
    });

    const txns = [feeTxn, assetTransferTxn, appCallTxn];
    algosdk.assignGroupID(txns);

    const signedTxns = txns.map(txn => txn.signTxn(account!.sk));
    const { txId } = await algodClient.sendRawTransaction(signedTxns).do();

    setMessage(`✅ Compra exitosa: ${item.name} - TxID: ${txId}`);
    await readAppGlobalState();
   } catch (error: any) {
    console.error("Error al procesar compra:", error);
    setMessage("❌ Error durante la compra. Revisa consola para más detalles.");
      }
  },
 });
};

 useEffect(() => {
  if (accountAddress) readAppGlobalState();
 }, [accountAddress, readAppGlobalState]);

 useEffect(() => {
 const checkOptIn = async () => {
  if (!account?.addr) return;
  try {
   const appInfo = await algodClient.accountApplicationInformation(account.addr, appId).do();
   if (appInfo['app-local-state']) {
    setHasOptedIn(true);
   }
  } catch (err) {
   console.warn("No opt-in aún o error verificando:", err);
  }
 };
 checkOptIn();
}, [account?.addr, algodClient]); 

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const categoryId = e.target.value;
    if (categoryId) {
      const element = document.getElementById(categoryId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };


 return (
 <div className="modal-marketplace">
  <h1>Marketplace Mox Holkan</h1>
  <p>Usa tus puntos UMQ para reclamar productos.</p>
  <p>UMQ usados: {(userUmqEnviados / 1e9).toFixed(2)} UMQ</p>

  {hasOptedIn ? (
   <button disabled={false} className="button-primary" onClick={optInToApp}>Ver productos</button>
  ) : (
   <div className="marketplace-content">
        <div className="category-nav">
          <label htmlFor="category-select">Ir a la sección: </label>
          <select id="category-select" onChange={handleCategoryChange} className="category-select">
            <option value="">Selecciona una categoría...</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.title}</option>
            ))}
          </select>
        </div>

        {categories.map((category) => {
          const categoryItems = items.filter(item => item.category === category.id);

          return (
            <section key={category.id} id={category.id} className="marketplace-section">
              <h2>{category.title}</h2>
              
              {categoryItems.length > 0 ? (
                <div className="items-grid">
                  {categoryItems.map((item) => (
                    <ItemCard key={item.id} item={item} onPurchase={handlePurchase} />
                  ))}
                </div>
              ) : (
                <p>No hay productos disponibles en esta categoría por el momento.</p>
              )}
            </section>
          );
        })}
   </div>
  )}

  <button className="button-exit" onClick={() => navigate("/home")}>Volver</button>
 </div>
);
};

export default Marketplace;


